<script lang="ts">
  import editorStore from '../editor.store';
  import {getEditorModules} from '../modules';
  import type {ToolbarAction} from './ToolbarModule';
  import ToolItem from './ToolItem.svelte';

  let toolbar: Array<ToolbarAction> = [];

  editorStore.subscribe(store => {
    const {activeComponent} = store;
    if (!activeComponent) {
      toolbar = [];
      return;
    } else {
      const modules = getEditorModules(activeComponent) || [];
      const toolbarActions = modules.reduce<Array<ToolbarAction>>((acc, module) => {
        if (!module.toolbarActions || module.toolbarActions.length == 0) return acc;
        return [...acc, ...module.toolbarActions];
      }, []);
      toolbar = toolbarActions;
    }
  });
</script>

<div id="toolbar" class=" flex justify-center space-x-1 px-4 py-2 text-sermon-gray-700">
  {#if toolbar.length}
    <div class="flex h-[60px] rounded-full bg-white px-6 py-3 shadow-md">
      {#each toolbar as item, index}
        <div class="flex space-x-2">
          <ToolItem {item} />
        </div>
        {#if index !== toolbar.length - 1}
          <div class="border-1 mx-2 my-auto h-6 border-l border-gray-300"></div>
        {/if}
      {/each}
    </div>
  {/if}
</div>

<style>
  div#toolbar {
    height: 65px;
  }
</style>
